import ZHCN from './zh-CN'
export default {
  // Vue3 插件：$t 挂到 globalProperties（原 Vue2 是 Vue.prototype.$t）
  install(app) {
    app.config.globalProperties.$t = (type) => {
      const area = (type && type.split('.')) || []
      let name = ''
      if (area.length > 0) {
        name = ZHCN[area[0]][area[1]]
      }
      return name
    }
  }
}
